export default __webpack_public_path__ + "static/media/Craftsman's Mitts.7a9f0b6f.jpg";